import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import getColorCode from 'src/utils/GetThemeColor';
import { ReactComponent as Refresh } from 'src/Images/icons/common/refresh.svg';
import { ReactComponent as Search } from 'src/Images/icons/common/search.svg';
import { ReactComponent as Create } from 'src/Images/icons/common/create.svg';
import { CustomToolTip } from 'src/utils/CustomToolTip';
import TableContent from 'src/components/Settings/QualityCheck/TableContent';
import Table from 'src/components/PendingGrnVehicleEntry/List/Table';
import { getQualityCheckList } from 'src/redux/Actions/VehicleTracking';
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';

export default function QualityCheckList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const authReducer = useSelector((state) => state.AuthReducer);

  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;

  const [tableSortOrder, setTableSortOrder] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const [searchInputChange, setSearchInputChange] = useState(null);
  const searchTexts = ['Quality Check Name'];

  useEffect(() => {
    dispatch(getQualityCheckList(tenantOrganisationId, searchInput));
  }, [dispatch, tenantOrganisationId, searchInput]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchInputChange(
        (prev) =>
          searchTexts[(searchTexts.indexOf(prev) + 1) % searchTexts.length],
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const tableHeaders = [
    { label: 'Quality Check Name', value: 'quality_check_name' },
    { label: 'Dimensions', value: 'dimensions' },
    { label: 'Products', value: 'products' },
  ];

  const handleTableSortOrder = (value) => setTableSortOrder(value);
  const handleSearchInput = (e) => setSearchInput(e.target.value);

  useSetBreadcrumbData(location.pathname, 'Quality check list');

  return (
    <div className="page-layout div-flex-column">
      <div className="div-space-between left-padding">
        <div className="div-flex-row cg-5">
          <Breadcrumb />
        </div>
        <Col xxl={2} xl={2} lg={2} className="p-0 m-0">
          <div className="input-wrapper">
            <input
              type="text"
              className="form-input-section input-icon-remove"
              placeholder={`Search by ${searchInputChange}`}
              value={searchInput}
              onChange={handleSearchInput}
            />
            <span className="form-input-section-icon">
              <Search
                className="icon-size-lg"
                color={getColorCode(themeColor)}
              />
            </span>
          </div>
        </Col>
      </div>

      <div className="div-space-between border-bottom slider-padding">
        <span className="text-xxl text-bold left-padding">Quality Checks</span>
        <div className="div-flex-row div-align-center cg-20 right-padding">
          <CustomToolTip title="Refresh" placement="bottom">
            <button
              aria-label="Refresh"
              className="icon-btn-none"
              onClick={() => window.location.reload()}
            >
              <Refresh className="icon-size-lg" color="#9F9F9F" />
            </button>
          </CustomToolTip>
        </div>
      </div>

      <Table
        headers={tableHeaders}
        minCellWidth={150}
        tableContent={<TableContent headers={tableHeaders} />}
        tableSortOrder={tableSortOrder}
        handleTableSortOrder={handleTableSortOrder}
      />
      <div className="footer-container left-padding">
        <div className="div-flex-row div-flex-end div-align-center footer-content-for-page">
          <button
            aria-label="button"
            className={`create-icon-btn theme-background-${themeColor}`}
            onClick={() => navigate('/create-quality-check/')}
          >
            <Create className="icon-size-lg" color="#FFFFFF" />
          </button>
        </div>
      </div>
    </div>
  );
}
